/*@ngInject*/
const ManageOperationController = function (localization, $element, $uibModal) {

    $element.addClass('manageOperation');

    this.isOpen = false;

    this.onIconClick = function () {
        this.isOpen = !this.isOpen;
    };

    this.backup = function () {
        this.closeDropDown();
        $uibModal.open({
            templateUrl: '/configuration/manageOperation/backup/backupModal.tpl.html',
            controller: 'backupModalController',
            windowClass: 'backupModal',
            resolve: {},
            keyboard: false,
            backdrop: 'static'
        });
    };

    this.restore = function () {
        this.closeDropDown();
        $uibModal.open({
            templateUrl: '/configuration/manageOperation/restore/restoreModal.tpl.html',
            controller: 'restoreModalController',
            windowClass: 'restoreModal',
            resolve: {},
            keyboard: false,
            backdrop: 'static'
        });
    };

    this.showHistoryModal = function () {
        this.closeDropDown();
        $uibModal.open({
            templateUrl: '/configuration/manageOperation/detailedHistory/detailedHistoryModal.tpl.html',
            controller: 'detailedHistoryModalController',
            windowClass: 'detailedHistoryModal',
            resolve: {},
            keyboard: false,
            backdrop: 'static'
        });
    };

    this.importClassCodesModal = function () {
        this.closeDropDown();
        $uibModal.open({
            templateUrl: '/configuration/manageOperation/importClassCodes/importClassCodesModal.tpl.html',
            controller: 'importClassCodesModalController',
            windowClass: 'importClassCodesModal',
            resolve: {},
            keyboard: false,
            backdrop: 'static'
        });
    };

    this.generateDataDictionary = function () {
        this.closeDropDown();
        $uibModal.open({
            templateUrl: '/configuration/manageOperation/generateDataDictionary/generateDataDictionaryModal.tpl.html',
            controller: 'generateDataDictionaryModalController',
            windowClass: 'generateDataDictionaryModal',
            resolve: {},
            keyboard: false,
            backdrop: 'static'
        });
    };

    this.closeDropDown = function () {
        this.isOpen = false;
    };
};

angular.module('ums.configuration')
    .controller('manageOperationController', ManageOperationController);
